// 新版本弹窗
<template>
  <div class="givePopup">
    <el-dialog
      :show-close="false"
      :visible.sync="dialogVisible"
      width="460px"
      :lock-scroll="false"
      :modal-append-to-body="false"
    >
      <div class="content">
        <div class="title">选择数量</div>

        <el-form size="mini" label-position="top" :model="form" ref="form">
          <el-form-item
            label="代金劵数量"
            prop="count"
            :rules="[{ required: true, message: '请输入代金劵数量', trigger: 'blur' }]"
          >
            <div class="amount-box">
              <el-input-number
                :controls="false"
                type="number"
                :step="1"
                :max="itemData.count"
                :min="1"
                v-model.number="form.count"
                placeholder="请输入代金劵数量"
                style="width: 110px"
              ></el-input-number>
              <div class="amount-box-1">张</div>
            </div>
          </el-form-item>
        </el-form>

        <div class="btns">
          <div class="desc">
            可赠送数量
            <span>（x{{ itemData.count }}）</span>
          </div>
          <div>
            <el-button @click="onclose">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <signInSelect
      ref="signInSelectRef"
      @cancel="signInSelectCancel"
      @confirm="signInSelectConfirm"
    />
  </div>
</template>

<script>
import signInSelect from "@/components/signIn/signInSelect.vue";
export default {
  components: {
    signInSelect,
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        count: 0,
        targetEmpUUID: null,
      },
      itemData: {
        type: null,
        amount: null,
        validUntil: null,
        state: null,
        source: null,
        count: null,
      },
    };
  },
  created() {},
  computed: {},
  methods: {
    onshow(itemData) {
      this.dialogVisible = true;
      this.itemData = itemData;
    },
    onclose() {
      this.dialogVisible = false;
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.onclose();
          this.signInSelectOnshow();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    signInSelectOnshow() {
      this.$refs.signInSelectRef.onshow();
    },
    signInSelectOnclose() {
      this.$refs.signInSelectRef.onclose();
    },
    //选取联系人取消
    signInSelectCancel() {
      this.onshow();
    },
    // 选取联系人确认
    signInSelectConfirm(targetEmpUUID) {
      this.form.targetEmpUUID = targetEmpUUID;
      this.postVoucherGift();
    },
    async postVoucherGift() {
      const { status, info } = await this.$api.postVoucherGift({
        ...this.itemData,
        ...this.form,
      });
      if (status === 200) {
        this.$message({
          message: info,
          type: "success",
        });
        this.signInSelectOnclose();
        this.$emit("success");
      } else {
        this.$message({
          message: info,
          type: "error",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  @include dialogDefStyle;
  .btns {
    justify-content: space-between;
    .desc {
      font-size: 14px;
      font-weight: 350;
      color: #666666;
      span {
        color: #262626;
      }
    }
  }
  .amount-box {
    display: flex;

    &-1 {
      margin-left: 10px;
    }
  }
}
</style>
